// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__gDGBv","title":"Header_title__1Mh1i","left":"Header_left__31NIm","clinicName":"Header_clinicName__1cVTB"};